import * as THREE from "three";
import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from "three-mesh-bvh";

// Installs three-mesh-bvh raycast acceleration. Meshes whose geometry carries
// a boundsTree raycast through the BVH (orders of magnitude faster); all other
// meshes keep stock three.js raycasting, so patching the prototype is safe.
// Type augmentation (boundsTree, Raycaster.firstHitOnly) ships with the
// library itself.

THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;

// Build a BVH for a mesh's geometry once; clones sharing the geometry share
// the tree.
export function ensureBoundsTree(mesh: THREE.Mesh): void {
  if (!mesh.geometry.boundsTree) mesh.geometry.computeBoundsTree();
}
